

import React, { memo, useMemo, useState } from 'react';
import cx from 'classnames';
import { FormModal, IFrame } from '../../../ui-kit';
import GetInTouchForm from './GetInTouchForm';
import GetInTouchSubmitted from './GetInTouchSubmitted';

import '../styles/_get-in-touch-modal.scss';

const TITLE = 'Get in touch';
const SUBTITLE = 'Please select a reason for getting in touch with us today, or leave a brief message.';
const EXTERNAL_FORM_URL = 'https://go.shootsta.com/l/882323/2021-06-01/wh7jb';
const EXTERNAL_FORM_HEIGHT = 500;










function handleSubmit(setSubmitting, setSubmitted, sendEmail, onClose, subject, optionalText) {
  setSubmitting(true);

  try {
    sendEmail({
      subject,
      optionalText
    });
    setSubmitting(false);
    setSubmitted(true);
    setTimeout(() => {
      onClose();
      setSubmitted(false);
    }, 3000);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('handleSubmit failed', e);
  }
}

function GetInTouch({
  visible,
  onClose,
  sendEmail = () => {},
  isExternalForm,
  externalFormUrl,
  className
}) {
  const [submitted, setSubmitted] = useState(false);

  const formModalProps = useMemo(() => isExternalForm ? {
    isFullWidth: true
  } : {
    title: submitted || TITLE,
    subtitle: submitted || SUBTITLE
  }, [submitted, isExternalForm]);

  const formModalContent = useMemo(() => {
    if (isExternalForm) {
      return <IFrame url={externalFormUrl || EXTERNAL_FORM_URL} height={EXTERNAL_FORM_HEIGHT} />;
    }

    return submitted ?
    <GetInTouchSubmitted /> :

    <GetInTouchForm
      onSubmit={(setSubmitting, subject, optionalText) =>
      handleSubmit(setSubmitting, setSubmitted, sendEmail, onClose, subject, optionalText)} />;



  }, [isExternalForm, submitted, sendEmail, onClose]);

  return (
    <div className={cx(
      'get-in-touch-modal',
      { 'get-in-touch-modal--submitted': submitted },
      { 'get-in-touch-modal--external-form': isExternalForm },
      className)}>

      <FormModal
        visible={visible}
        onClose={onClose}
        hideFooter
        {...formModalProps}>

        {formModalContent}
      </FormModal>
    </div>);

}

export default memo(GetInTouch);